import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { site, methodes, parcours, publics } from '../data/site';
import { formations } from '../data/formations';
import { QualiopiBadge } from '../components/QualiopiBadge';
import { useSeo } from '../hooks/useSeo';
export function NotreApproche() {
  useSeo({
    title: 'Notre approche — Zillenium Academy, organisme de formation à Joigny',
    description: 'Méthode pédagogique, accompagnement et modalités générales de Zillenium Academy, organisme de formation professionnelle certifié Qualiopi à Joigny (Yonne).'
  });
  return <>
      <section className="border-b border-surface-line bg-surface-soft" data-id="element-457" data-mp="1pdjcjrk5u1xr">
        <div className="mx-auto grid max-w-content items-center gap-12 px-5 py-14 lg:grid-cols-[1.2fr_0.8fr] lg:px-8 lg:py-16" data-id="element-458" data-mp="1keyarnp9fa77">
          <div data-id="element-459" data-mp="e18sc9jhfe4x">
            <QualiopiBadge data-id="element-460" data-mp="dxur54mk1az2" />
            <h1 className="mt-6 max-w-2xl text-4xl font-extrabold leading-tight text-ink md:text-[46px]" data-id="element-461" data-mp="914c8kmhklf8">
              La formation utile, pas la formation décorative
            </h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-ink-muted" data-id="element-462" data-mp="3288htvafzvue">
              Zillenium Academy est un organisme de formation professionnelle certifié Qualiopi
              installé à {site.ville}, dans l’{site.departement}. Nos parcours couvrent la
              transformation digitale, la communication, le commerce, le management et
              l’entrepreneuriat.
            </p>
          </div>
          <img src={site.imageApproche} alt="Atelier collectif animé par Zillenium Academy" className="aspect-[4/5] w-full rounded-2xl object-cover" data-id="element-463" data-mp="2j9wbsietv231" />
        </div>
      </section>

      <section className="mx-auto max-w-content px-5 py-16 lg:px-8" data-id="element-464" data-mp="29kcpf2rwoq3f">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-465" data-mp="1vj8oopwcc5vw">
          <h2 className="text-3xl font-bold leading-tight text-ink md:text-[38px]" data-id="element-466" data-mp="1vm4l29sjimi8">
            Notre méthode pédagogique
          </h2>
          <div className="space-y-6 text-[17px] leading-relaxed text-ink-muted" data-id="element-467" data-mp="636ahuewmdls">
            <p data-id="element-468" data-mp="1c6in3kn6lq5">
              Nos formations mobilisent des apports théoriques, des démonstrations, des ateliers,
              des études de cas, des exercices, des mises en situation et des échanges guidés. Le
              dosage dépend du parcours et du profil des participants.
            </p>
            <p data-id="element-469" data-mp="p18xk3nw60gy">
              L’objectif reste le même : que chaque séquence débouche sur quelque chose d’utilisable
              — un contenu, une organisation, un plan d’action, un réflexe managérial.
            </p>
          </div>
        </div>

        <div className="mt-12 grid gap-x-12 gap-y-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-470" data-mp="fz9dt3lhsiab">
          {methodes.map(m => <article key={m.titre} className="border-t-2 border-accent-500 pt-5" data-id="element-471" data-mp="b3u48nuip8jp">
              <h3 className="text-lg font-bold text-ink" data-id="element-472" data-mp="30smm6frn4qhq">{m.titre}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-473" data-mp="2vrp380yt3sf6">{m.texte}</p>
            </article>)}
        </div>
      </section>

      <section className="bg-surface-soft" data-id="element-474" data-mp="2lm72ycif8cgz">
        <div className="mx-auto max-w-content px-5 py-16 lg:px-8" data-id="element-475" data-mp="2qmbj21ff356o">
          <h2 className="text-3xl font-bold text-ink" data-id="element-476" data-mp="2vm7s4f2z1mt3">L’accompagnement, étape par étape</h2>
          <ol className="mt-10 grid gap-x-8 gap-y-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-477" data-mp="30cxvjmru7fl5">
            {parcours.map((e, i) => <li key={e.titre} data-id="element-478" data-mp="34f1a4k9sz0an" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-479" data-mp="34dzwc81ejzp8">
                  <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-900 text-sm font-bold text-white" data-id="element-480" data-mp="39d32xwx16dzb">
                    {i + 1}
                  </span>
                  <span className="h-px flex-1 bg-surface-line" aria-hidden data-id="element-481" data-mp="3jcbs8cgyb4fc" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-ink" data-id="element-482" data-mp="1jz7oq89c2d7t">{e.titre}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-483" data-mp="1oxreykuymb5z">{e.texte}</p>
              </li>)}
          </ol>

          <div className="mt-12 rounded-xl border border-surface-line bg-white p-7" data-id="element-484" data-mp="3fdto2b6j313b">
            <h3 className="text-lg font-bold text-ink" data-id="element-485" data-mp="3agl1zzi9ecws">Documents remis et suivi qualité</h3>
            <p className="mt-2 max-w-3xl text-[15px] leading-relaxed text-ink-muted" data-id="element-486" data-mp="3og2uopyoeabf">
              À l’issue du parcours : attestation de fin de formation ou attestation de réalisation,
              émargements et questionnaire de satisfaction. Les retours des bénéficiaires sont
              analysés afin d’ajuster les prestations lorsque cela est nécessaire.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-content px-5 py-16 lg:px-8" data-id="element-487" data-mp="35hguddazgn8k">
        <h2 className="text-3xl font-bold text-ink" data-id="element-488" data-mp="30pgo734bky3j">À qui s’adressent nos formations ?</h2>
        <ul className="mt-6 flex flex-wrap gap-2" data-id="element-489" data-mp="2d04gy8sjz03v">
          {publics.map(p => <li key={p} className="rounded-full border border-surface-line bg-surface-soft px-4 py-2 text-sm font-medium text-brand-800" data-id="element-490" data-mp="281b2ad1j5324">
              {p}
            </li>)}
        </ul>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-491" data-mp="sb0qgxyfp871">
          {formations.map(f => <Link key={f.slug} to={`/formations/${f.slug}`} className="flex items-center justify-between gap-4 rounded-xl border border-surface-line bg-white p-5 transition-colors duration-150 ease-out hover:border-accent-400" data-id="element-492" data-mp="ejdiw1z1kd8y">
              <span data-id="element-493" data-mp="1b9d1kp8wos59">
                <span className="text-xs font-semibold text-accent-600" data-id="element-494" data-mp="1b7tkwxjc8f2y">{f.categorie}</span>
                <span className="mt-1 block font-bold leading-snug text-ink" data-id="element-495" data-mp="x9va224870s7">{f.titre}</span>
              </span>
              <ArrowRightIcon size={18} className="shrink-0 text-brand-700" aria-hidden data-id="element-496" data-mp="126vcm31v9lek" />
            </Link>)}
        </div>
      </section>
    </>;
}